
export default {
  data() {
    return {
      textIndex: null,
      titles: [
        `DON'T STOP BELIEVIN'`,
        `SHAKE IT OFF`,
        `ON THE EDGE OF GLORY`,
        `CAME IN LIKE A WRECKING BALL`,
        `LET ME UPGRADE U`,
        `HIT ME BABY ONE MORE TIME`,
        `NEVER GO OUT OF STYLE`
      ],
      subtitles: [
        `In the power of music as a passion point to reach your audience.`,
        `Revitalize your strategy, reach users where they love to spend time most.`,
        `Boost and amplify your brand with cutting-edge advertising solutions.`,
        `Create lasting impact with our immersive ads for music enthusiasts.`,
        `Step up from sandwich boards and paper fliers and into immersive, full-screen digital advertising.`,
        `Reach your audience where they keep coming back for more.`,
        `Stay up to date with the latest trends of digital advertising and user behavior.`
      ]
    }
  },
  mounted() {
    this.textIndex = this.randomNumber(0, 6)
  },
  methods: {
    randomNumber(from, to) {
      return Math.floor(Math.random() * (to - from + 1) + from)
    }
  }
}
